import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';



function Notifications({setIsNotificationsOpen}) {


    const { t } = useTranslation()

    const [notifications, setNotifications] = useState([])
    const [notification, setNotification] = useState(false)
    const [part, setPart] = useState({})

    useEffect(() => {
        const getDetails = async () => {
        
            const token = localStorage.getItem('token');
            
            if (!token) {
                console.error("Token is missing!");
                return;
            }

            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/get-notifications`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    
                })
    
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.details) {
                        setNotifications(data.details)
                    }
                    console.log(data.details)

                    
                  }
            } catch (error) {
                console.error("Error fetching details:", error);

            }
          
    }
    getDetails()
    }, [])

    function Notification({setNotification, notify}) {

        return (
            <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <div className={'profile-modal-container-wrap'}>
                    <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setNotification(false)}/>
                    <div className={'profile-modal-title'}>
                        <span>{t("mp_notifications")}</span>
                    </div>
                    <div>
                        <div className={'notification-title-wrapper'}>{notify.title ? notify.title : ""}</div>
                        <div style={{"fontSize": "15px"}}>{notify.body ? `${t(`${notify.body}`)}` : ""}</div>
                    </div>
                </div>
            </div>
        </div>
        )
    }



    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <div className={'profile-modal-container-wrap'}>
                    <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsNotificationsOpen(false)}/>
                    <div className={'profile-modal-title'}>
                        <span>{t("mp_notifications")}</span>
                    </div>
                    <div className={'notifications-list-container'}>

                    {notifications.length > 0 ? notifications.map((part, index) => (
                    <div className={`notifications-list-item-wrap ${part.read ? "" : "active"}`} onClick={() => {
                        setPart(part)
                        setNotification(true)
                    }}>
                        <div className={'notifications-list-item-title'}>
                            <span style={{"fontWeight": "600"}}>{part.title}</span>
                        </div>
                        <div className={'notifications-list-item-text'}>
                            <p>
                                {t(`${part.body}`)}
                            </p>
                        </div>
                        
                    </div>                        
                       
                    )) : ""}


                        {/* <div className={`notifications-list-item-wrap active`}>
                            <div className={'notifications-list-item-title'}>
                                <span style={{"fontWeight": "600"}}>Notifications title</span>
                            </div>
                            <div className={'notifications-list-item-text'}>
                                <p>
                                Welcome to AviatorWinn. Thank you for choosing us. As a thank you, 
                                we will give you a 200% bonus on your first deposit for a replenishment of $ 50. We wish you success and big wins
                                </p>
                            </div>
                        </div> */}

                        


                    </div>
                </div>
            </div>
            {notification && <Notification setNotification={setNotification} notify={part} />}
        </div>
        
    )
}

export default Notifications;